import moment from 'moment';
import { InsightTimeline } from './InsightTimeline';
import { ActionTimeline } from './ActionTimeline';
import { EventTimeline } from './EventTimeline';
import { getWellbeingIcon, isValidEvent } from './helpers';
import { ICON_TYPES, TREE_TYPES } from './helpers/types';

export const DataMapperTimeline = (
  events,
  insights,
  actions,
  profileChecks,
  startDate,
  endDate,
  isAutomedic,
) => {
  let allData = {
    groups: [],
    items: [],
  };

  const tempGroup = {
    id: null,
    stackItems: false,
    root: true,
    parent: null,
    cnt: 0,
    title: null,
  };

  const tempItem = {
    id: null,
    group: null,
    start_time: null,
    end_time: null,
    type: ICON_TYPES.DOT_BLUE,
    cnt: 0,
    showInSimple: true,
    showInComplex: false,
    showInExpanded: true,
    showInCollapsed: true,
    order: 0,
  };

  let groupKey = 0;
  let itemKey = 0;

  function processEvent(ev, groupId, root, tree2, tree1) {
    let iconType = ICON_TYPES.DOT_BLUE;

    if (ev.settings?.dosageChange) {
      iconType = ICON_TYPES.PURPLE_PENCIL;
    } else if (ev.survey_type) {
      iconType = getWellbeingIcon(ev);
    }

    if (isValidEvent(ev)) {
      allData.items.push(
        EventTimeline(
          ev,
          iconType,
          groupId,
          root,
          ++itemKey,
          itemKey,
          tree2,
          tree1,
          isAutomedic,
        ),
      );
    }
  }

  function processInsights(insightsData, groupId, parentName) {
    Object.keys(insightsData).forEach(function (key) {
      if (insightsData[key]['insight']?.id) {
        allData.items.push(
          InsightTimeline(
            insightsData[key]['insight'],
            groupId,
            ++itemKey,
            itemKey,
            parentName,
          ),
        );
      }
    });
  }
  if (actions.length > 0) {
    let group = {
      ...tempGroup,
      id: ++groupKey,
      title: 'Actions',
      group_type: 'Actions',
    };
    allData.groups.push(group);

    const actionItem = {
      type: ICON_TYPES.ACTION,
      cnt: 0,
      showInSimple: true,
      showInComplex: true,
      showInExpanded: true,
      showInCollapsed: true,
    };

    actions.forEach((action) => {
      let Item = {
        ...actionItem,
        ...action,
        event_id: action.id,
        id: ++itemKey,
        group: group.id,
        start_time: moment(action.created_at).valueOf(),
        end_time: action.ended_at
          ? moment(action.ended_at).valueOf()
          : moment(Date.now()).valueOf(),
        order: itemKey,
        group_type: group.group_type,
        parent_name: group.title,
      };
      allData.items.push(Item);
      itemKey++;
    });
  }

  if (events) {
    Object.keys(events).forEach(function (root) {
      allData.groups.push({ ...tempGroup, id: ++groupKey, title: root });
      let parent_tree1_id = groupKey;

      Object.keys(events[root]).forEach(function (tree1) {
        if (tree1 === TREE_TYPES.EVENTS) {
          Object.keys(events[root][tree1]).forEach(function (tree2) {
            const ev = events[root][tree1][tree2];
            processEvent(ev, groupKey, root, tree2, root);
          });
        } else if (tree1 === TREE_TYPES.INSIGHTS) {
          processInsights(events[root][tree1], groupKey, root);
        } else {
          allData.groups.push({
            ...tempGroup,
            id: ++groupKey,
            root: false,
            parent: parent_tree1_id,
            title: tree1.charAt(0) + tree1.slice(1).toLowerCase(),
            treeLevel: 1,
            rootId: parent_tree1_id,
            stackItems: true,
          });

          let parent_tree2_id = groupKey;
          Object.keys(events[root][tree1]).forEach(function (tree2) {
            if (tree2 === TREE_TYPES.EVENTS) {
              Object.keys(events[root][tree1][tree2]).forEach(function (tree3) {
                const ev = events[root][tree1][tree2][tree3];
                processEvent(ev, groupKey, root, tree2, tree1);
              });
            } else if (tree2 === TREE_TYPES.INSIGHTS) {
              processInsights(events[root][tree1][tree2], groupKey, tree1);
            } else {
              allData.groups.push({
                ...tempGroup,
                id: ++groupKey,
                root: false,
                parent: parent_tree2_id,
                title: tree2.charAt(0) + tree2.slice(1).toLowerCase(),
                treeLevel: 2,
                rootId: parent_tree1_id,
              });

              Object.keys(events[root][tree1][tree2]).forEach(function (tree3) {
                if (tree3 === TREE_TYPES.EVENTS) {
                  Object.keys(events[root][tree1][tree2][tree3]).forEach(
                    function (tree4) {
                      const ev = events[root][tree1][tree2][tree3][tree4];
                      processEvent(ev, groupKey, root, tree2, tree1);
                    },
                  );
                } else if (tree3 === TREE_TYPES.INSIGHTS) {
                  processInsights(
                    events[root][tree1][tree2][tree3],
                    groupKey,
                    tree1,
                  );
                }
              });
            }
          });
        }
      });
    });
  }

  if (profileChecks != null && Object.entries(profileChecks).length > 0) {
    let group = {
      ...tempGroup,
      id: ++groupKey,
      title: 'Profile Checks',
      group_type: 'Profile Checks',
    };
    allData.groups.push(group);

    const profileCheckItem = {
      type: ICON_TYPES.EYE,
      cnt: 0,
      showInSimple: true,
      showInComplex: true,
      showInExpanded: true,
      showInCollapsed: true,
    };

    Object.entries(profileChecks).forEach((check) => {
      let Item = {
        ...profileCheckItem,
        checks: check[1],
        event_id: check.id,
        id: ++itemKey,
        group: group.id,
        start_time: moment(check[0]).valueOf(),
        end_time: moment(check[0]).add(1, 'hour').valueOf(),
        order: allData.items.length + 1,
        group_type: group.group_type,
        parent_name: group.title,
      };
      allData.items.push(Item);
      itemKey++;
    });
  }

  allData.items.sort((a, b) => a.order - b.order);

  return allData;
};
